module.exports = __webpack_public_path__ + "img/04_towfiqu-barbhuiya.5ada7d08.jpg";